import { useQueryWithUserId } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';

/**
 * This query key is used to track the list of field types to update.
 */
const FIELDS_TO_UPDATE_TYPES_LIST_KEY = 'fields-to-update-type-list-query';

/**
 * This useQuery hook fetches the list of field types to update for
 * the package details for an inbound transaction.
 */
export const useFetchFieldsToUpdateTypeQuery = (enabled: boolean) => {
  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    enabled,
    queryKey: [FIELDS_TO_UPDATE_TYPES_LIST_KEY],
    networkMode: 'always',
    queryFn: INBOUND_API.fetchFieldToUpdateTypesList,
  });

  return {
    error,
    isError,
    data,
    isPending,
    refetchInboundTypes: refetch,
  };
};
